import styled from "styled-components";

export const container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    grid-column-start: 2;
    grid-column-end: 2;
    padding: 5rem 5rem;

    

    .container__balance{
        display: inherit;
        justify-content: space-between;
        width: 100%;
        margin: 2rem 0;
    }

    @media (max-width: 576px){
        width: 100%;
        padding: 5rem 1rem;

        .container__balance{
            flex-direction: column;
        }
    }

    @media (min-width: 576px) and (max-width: 767px){
        width: 100%;
        padding: 5rem 2rem;
    }

    @media (min-width: 767.98px) and (max-width: 999px){
        width: 100%;
        padding: 5rem 3.5rem;
    }

    @media (min-width: 999.98px) and (max-width: 1250px){
        width: 52vw;
        padding: 5rem 3.5rem;
    }


`